'use strict';

var _Editor = require('./components/Editor');

var _Editor2 = _interopRequireDefault(_Editor);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
    Editor: _Editor2.default,
    stateToHTML: _utils.stateToHTML
};


//////////////////
// WEBPACK FOOTER
// ./js/src/index.js
// module id = 63
// module chunks = 0